var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0656 11.7452C16.299 11.7452 19.7308 10.1172 19.7308 8.10893C19.7308 6.10067 16.299 4.47266 12.0656 4.47266C7.83222 4.47266 4.40039 6.10067 4.40039 8.10893C4.40039 10.1172 7.83222 11.7452 12.0656 11.7452ZM12.0656 13.5192C8.60857 13.5192 5.6893 12.4352 4.73329 10.9414C4.51989 11.2743 4.40039 11.6328 4.40039 11.9999C4.40039 14.0058 7.8318 15.6361 12.0656 15.6361C16.2994 15.6361 19.7308 14.0058 19.7308 11.9999C19.7308 11.6328 19.6113 11.2743 19.3979 10.9414C18.4419 12.4352 15.5226 13.5192 12.0656 13.5192ZM4.73329 14.8242C5.6893 16.318 8.60857 17.402 12.0656 17.402C15.5226 17.402 18.4419 16.318 19.3979 14.8242C19.6113 15.1571 19.7308 15.5156 19.7308 15.8827C19.7308 17.8886 16.2994 19.5189 12.0656 19.5189C7.8318 19.5189 4.40039 17.8886 4.40039 15.8827C4.40039 15.5156 4.51989 15.1571 4.73329 14.8242Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon-sales.901011c48670845675170ed3cee8744c.svg";
export { ForwardRef as ReactComponent };